<template>
  <div v-if="visible" class="br-status-modal">
    <div class="br-status-modal__scrim" @click="onScrim"></div>
    <div
      class="br-status-modal__dialog"
      :class="'br-status-modal__dialog--' + variant"
      role="dialog"
      aria-modal="true"
    >
      <div class="br-status-modal__main">
        <div class="br-status-modal__icon-wrap" aria-hidden="true">
          <img
            :src="iconUrl"
            class="br-status-modal__icon-img"
            :width="iconSize"
            :height="iconSize"
            alt=""
          />
        </div>
        <div class="br-status-modal__text">
          <div class="br-status-modal__title">{{ title }}</div>
          <div class="br-status-modal__body" v-html="body"></div>
        </div>
      </div>
      <div class="br-status-modal__actions">
        <button
          v-if="secondaryLabel"
          type="button"
          class="br-status-modal__secondary"
          @click="$emit('secondary')"
        >
          {{ secondaryLabel }}
        </button>
        <button type="button" class="br-status-modal__primary" @click="$emit('primary')">
          {{ primaryLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { BR_LICENSE_ASSETS } from '../../../constants/brLicenseAssets';

const ICONS = {
  reminder: BR_LICENSE_ASSETS.docUploadIcon,
  approved: BR_LICENSE_ASSETS.docApprovedIcon,
  rejected: BR_LICENSE_ASSETS.docUploadRejectIcon,
  // 临期提醒与提交提醒同用 Doc_Upload.png（Figma）
  expiring: BR_LICENSE_ASSETS.docUploadIcon,
};

export default {
  name: 'BrStatusModal',
  props: {
    visible: { type: Boolean, default: false },
    variant: {
      type: String,
      default: 'approved',
      validator: (v) => ['reminder', 'approved', 'rejected', 'expiring'].includes(v),
    },
    title: { type: String, required: true },
    body: { type: String, required: true },
    primaryLabel: { type: String, required: true },
    secondaryLabel: { type: String, default: '' },
    /** 点遮罩：none=不可关闭（默认）；primary/secondary=触发对应按钮事件 */
    scrimAction: {
      type: String,
      default: 'none',
      validator: (v) => ['primary', 'secondary', 'none'].includes(v),
    },
  },
  computed: {
    iconUrl() {
      return ICONS[this.variant] || ICONS.approved;
    },
    /** 通过弹窗图标 72×72；其余 96 */
    iconSize() {
      return this.variant === 'approved' ? 72 : 96;
    },
  },
  methods: {
    onScrim() {
      if (this.scrimAction === 'none') {
        return;
      }
      this.$emit(this.scrimAction);
    },
  },
};
</script>
